import { HttpHeaders } from '@angular/common/http';

export const MESSAGE_LIFE = 4000;

export const ERROR_MAP: Record<number, { summary: string; detail: string }> = {
  400: {
    summary: 'Richiesta non valida',
    detail: 'I dati inviati non sono corretti.',
  },
  401: {
    summary: 'Non autorizzato',
    detail: 'Sessione scaduta, effettua nuovamente il login.',
  },
  403: {
    summary: 'Accesso negato',
    detail: 'Non hai i permessi per eseguire questa operazione.',
  },
  404: {
    summary: 'Non trovato',
    detail: 'La risorsa richiesta non esiste.',
  },
  500: {
    summary: 'Errore del server',
    detail: 'Si è verificato un errore inaspettato.',
  },
};

/**
 * HTTP statuses to exclude from the global error popup.
 * Add this header to a request to silence specific error statuses.
 *
 * @example
 * this.http.get('/api/resource', {
 *   headers: { 'X-Skip-Error-Popup': '404' }        // single status
 *   headers: { 'X-Skip-Error-Popup': '404,403' }    // multiple statuses
 * })
 */
const SKIP_ERROR_POPUP_HEADER = 'X-Skip-Error-Popup';

export const skipErrorPopup = (...statuses: number[]): HttpHeaders => {
  return new HttpHeaders({ [SKIP_ERROR_POPUP_HEADER]: statuses.join(',') });
};
